export class PhoneUtils {
    /**
     * 전화번호를 포맷팅합니다
     * @param phone 전화번호 (문자열 또는 숫자)
     * @returns 포맷팅된 전화번호
     */
    static format(phone: string | number): string {
        if (!phone) return '';

        // 숫자만 추출
        const phoneStr = phone.toString().replace(/\D/g, '');

        // 전화번호 길이에 따른 포맷팅
        if (phoneStr.length === 11) {
            // 휴대폰: 010-1234-5678
            return phoneStr.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
        } else if (phoneStr.length === 10) {
            // 일반전화: 02-123-4567 또는 031-123-4567
            if (phoneStr.startsWith('02')) {
                return phoneStr.replace(/(\d{2})(\d{3,4})(\d{4})/, '$1-$2-$3');
            } else {
                return phoneStr.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            }
        } else if (phoneStr.length === 9) {
            // 일반전화: 02-123-4567
            return phoneStr.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
        } else if (phoneStr.length === 8) {
            // 지역번호 없는 경우: 1234-5678
            return phoneStr.replace(/(\d{4})(\d{4})/, '$1-$2');
        }

        // 그 외의 경우 원본 반환
        return phoneStr;
    }

    /**
     * 전화번호에서 하이픈을 제거합니다
     * @param phone 전화번호
     * @returns 하이픈이 제거된 전화번호
     */
    static removeHyphen(phone: string): string {
        if (!phone) return '';
        return phone.replace(/-/g, '');
    }

    /**
     * 전화번호 유효성을 검사합니다
     * @param phone 전화번호
     * @returns 유효한 전화번호인지 여부
     */
    static isValid(phone: string | number): boolean {
        if (!phone) return false;

        const phoneStr = phone.toString().replace(/\D/g, '');

        // 8자리 이상 11자리 이하
        return phoneStr.length >= 8 && phoneStr.length <= 11;
    }

    /**
     * 휴대폰 번호인지 확인합니다
     * @param phone 전화번호
     * @returns 휴대폰 번호인지 여부
     */
    static isMobile(phone: string | number): boolean {
        if (!phone) return false;

        const phoneStr = phone.toString().replace(/\D/g, '');

        // 010, 011, 016, 017, 018, 019로 시작하는 11자리
        return phoneStr.length === 11 && /^01[0-9]/.test(phoneStr);
    }

    /**
     * 전화번호를 마스킹합니다 (예: 010-1234-5678 -> 010-****-5678)
     * @param phone 전화번호
     * @param maskChar 마스킹할 문자 (기본값: '*')
     * @returns 마스킹된 전화번호
     */
    static mask(phone: string | number, maskChar: string = '*'): string {
        const formatted = this.format(phone);
        if (!formatted) return '';

        // 휴대폰 번호인 경우 중간 4자리 마스킹
        if (this.isMobile(phone)) {
            return formatted.replace(
                /(\d{3})-(\d{4})-(\d{4})/,
                `$1-${maskChar.repeat(4)}-$3`,
            );
        }

        // 일반 전화번호인 경우 마지막 4자리 중 앞 2자리 마스킹
        return formatted.replace(
            /(\d+)-(\d+)-(\d{2})(\d{2})/,
            `$1-$2-${maskChar.repeat(2)}$4`,
        );
    }
}
